import type { APIDependencies, HCInstance, HCVersion } from "./types";
import { HCv3 } from "../v3";
import { deps } from "../api/index"
import { HCv4 } from "../v4";

export function create(version: HCVersion, apiDependencies: APIDependencies[] = []): HCInstance {
  let api: Partial<Record<APIDependencies, any>> | null = null

  if (apiDependencies.length > 0) {
    const result: Partial<Record<APIDependencies, any>> = {}
    for (const dep of apiDependencies) result[dep] = deps[dep]
    api = result
  }

  switch (version) {
    case "v3":
      return new HCv3(api);
    case "v4":
      return new HCv4(api);
    default:
      throw new Error(`Unsupported HC version: ${version}`);
  }
}
